import { useMemo, useRef, useState } from 'react';
import { ReactSimpleComponentProps } from '@/custom-types';
import { UpdateContractInput } from '@/graphql/generated';
import { UpdateContractFormModalContext, UpdateContractFormModalContextProps } from './UpdateContractFormModalContext';

export const UpdateContractFormModalContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const contractDataRef = useRef<UpdateContractInput | null>(null)
  const [isOpen, setOpen] = useState(false)

  const actions = useMemo<Omit<UpdateContractFormModalContextProps, 'contractData' | 'isOpen'>>(() => ({
    closeModal: () => {
      setOpen(false)
      contractDataRef.current = null
    },

    openModal: (contractData?: UpdateContractInput) => {
      setOpen(true)

      if (contractData) contractDataRef.current = contractData
    },
  }), [])

  return (
    <UpdateContractFormModalContext.Provider value={{ ...actions, isOpen, contractData: contractDataRef.current}}>
      {children}
    </UpdateContractFormModalContext.Provider>
  )
}